import ImageModel from '@/models/image.model';

export default interface SmartOfferModel {
  id: string;
  title: string;
  buttonText: string;
  description: string;
  discountAmount: number;
  discountType: string;
  productId: string;
  productType: string;
  displayType: SMART_OFFER_TYPES;
  product: {
    thumbnail: ImageModel;
    icon: ImageModel;
    title: string;
    targetId?: string;
    slug: string;
    price?: number;
    lastPrice?: number;
    discount?: number;
    targetSlug?: string;
  };
  showDescription?: boolean;
  slug?: string;
  displayDelay?: number;
}

export enum SMART_OFFER_TYPES {
  SIDE_IN = 'sidein',
  POP_UP = 'popup',
  IN_LINE = 'inline',
}

// Mount point rendered inside the cart page so the mobile in-line smart offer can be
// portaled there (below the site header, above the cart card) instead of being fixed.
export const CART_INLINE_SMART_OFFER_MOUNT_ID = 'cart-inline-smart-offer-mount';
